export default "__VITE_ASSET__vR0wdIR8__"